export default __webpack_public_path__ + "static/media/109.6531b51d.jpg";